<template>
    <kgr-form-scaffold
        :pending="pending"
        @primaryBtnClicked="addDog"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-dog-create-form
            :new-dog="dog"
            :error="error"
            :club-id="clubId"
            @update="updateDog"
            @enter="addDog"
        />
    </kgr-form-scaffold>
</template>

<script>
import Dog from '../../js/dto/Dog.js';
import DogCreateForm from '../../components/dog/DogForm.vue';
import DogRepository from '../../js/repository/DogRepository.js';
import Error from '../../js/model/Error.js';
import FormScaffold from '../../components/common/form/FormScaffold.vue';

export default {
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-dog-create-form': DogCreateForm,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            dog: new Dog(),
            error: new Error(),
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        updateDog(dog) {
            this.dog = dog;
        },
        addDog() {
            this.pending = true;

            DogRepository.create(this.clubId, this.dog)
                .then((id) => {
                    this.$notify.success('Hund erfolgreich angelegt', {}, { saveInSession: true });
                    window.location = `/backend/clubs/dogs/${id}/edit`;
                })
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                    this.pending = false;
                });
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
